export function isRole(claim: Role | string | unknown | null): claim is Role {
  return claim !== null && typeof claim === 'string';
}
